import { CubeQuery } from '@/types/cube';

export const ChannelFocusKeys = {
  all: ['channelFocus'] as const,
  coverage: (query: CubeQuery) => [...ChannelFocusKeys.all, 'coverage', query] as const,
  coverageByEmployee: (query: CubeQuery) => [...ChannelFocusKeys.all, 'coverage-by-employee', query] as const,
  adoptionAnalysis: (query: CubeQuery) => [...ChannelFocusKeys.all, 'adoption-analysis', query] as const,
  splitAnalysisTooltip: (query: CubeQuery) => [...ChannelFocusKeys.all, 'split2-analysis-tooltip', query] as const,
  splitAnalysis: (query: CubeQuery) => [...ChannelFocusKeys.all, 'split-analysis', query] as const,
  productMessage: (query: CubeQuery) => [...ChannelFocusKeys.all, 'product-message', query] as const,
  insightsByEmployee: (query: CubeQuery) => [...ChannelFocusKeys.all, 'insights-by-employee', query] as const,
};
